import _ from 'lodash'

import i18n from 'modules/core/lib/i18n'

import type { AxisNames } from '.'
import { DimensionsGenerator } from './dimensions'

export default class PointDimensions {
  public id
  public axis
  public memoizedObject

  /**
   * PointDimensions - Use this class to encapsulate the common logic in order to generate
   * the data struture for Area and Lines chart.
   * @constructor
   * @param id - Provide a sql report o a builder report
   * @param axis - Provide a sql report o a builder report
   * @param memoizeObject - Provide a sql report o a builder report
   */
  constructor(id: string, axis: AxisNames, memoizedObject: object) {
    this.id = id
    this.axis = axis
    this.memoizedObject = memoizedObject
  }

  /**
   * call - Returns two objects in order to generate a chart with two dimensions (X axis and Y Axis)
   * or in another hand for two dimensions and besides group these values (Group by).
   * @method
   */
  call() {
    return [this.twoDimensionGenerator(), this.threeDimensionsGenerator()]
  }

  /**
   * twoDimensionGenerator - returns a DimensionsGenerator that is ready to generate values for
   * two dimensions (X axis and Y axis) for Lines and Area charts.
   * @method
   */
  private twoDimensionGenerator() {
    const { xAxis, yAxis } = this.axis

    return new DimensionsGenerator(
      (item) => {
        return {
          x: item[xAxis] || i18n.t('common.missing_field'),
          y: item[yAxis],
        }
      },
      (processedData) => {
        return [
          {
            id: this.id,
            data: processedData,
          },
        ]
      }
    )
  }

  /**
   * threeDimensionGenerator - returns a DimensionsGenerator that is ready to generate values for
   * two dimensions (X axis and Y axis) and besides group these values (Group by) for Lines and Area charts.
   * @method
   */
  private threeDimensionsGenerator() {
    const { xAxis, yAxis } = this.axis

    return new DimensionsGenerator(
      (group, key) => {
        const result = Object.keys(group).reduce(
          (memo, key) => {
            const row = group[key]

            return {
              ...memo,
              [row[xAxis ?? i18n.t('common.missing_field')]]: row[yAxis],
            }
          },
          { ...this.memoizedObject }
        )

        const data = _.map(result, (value, key) => ({
          x: key,
          y: value,
        }))

        return {
          id: key != 'null' ? key : i18n.t('common.missing_field'),
          data,
        }
      },
      (processedData) => processedData
    )
  }
}
